import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import thirdBridgeLogo from '@assets/ThirdBridgeHeaderLogo.svg';
import { ImgWrapper, Title, ButtonContainer } from '@layout/Header';
import { FlexContainer } from '@layout';
import { Button } from '@atoms';
import CreateButton from './CreateButton';
import messages from './messages';

const Header = ({
  title,
  logoutOnClick,
  newConferenceOnClick,
  newTranscriptOnClick,
  newOrganizationOnClick,
  email,
  logoinOnClick,
}) => (
  <FlexContainer>
    <FlexContainer vertical>
      <ImgWrapper>
        <img src={thirdBridgeLogo} alt="Third Bridge logo" />
      </ImgWrapper>
      <Title>{title}</Title>
    </FlexContainer>
    <ButtonContainer>
      {/* TODO: looks like anti-pattern, research how it could be implemented in the react way */}
      <Switch>
        <Route
          path="/"
          exact
          render={() => (
            <CreateButton
              onClickHandler={newConferenceOnClick}
              iconName="conferenceWhite"
              message={messages.createConference}
            />
          )}
        />
        <Route
          path="/transcripts"
          exact
          render={() => (
            <CreateButton
              onClickHandler={newTranscriptOnClick}
              iconName="transcriptWhite"
              message={messages.createTranscript}
            />
          )}
        />
        <Route
          path="/organizations"
          exact
          render={() => (
            <CreateButton
              onClickHandler={newOrganizationOnClick}
              iconName="organizationsPrimary"
              message={messages.createOrganization}
            />
          )}
        />
      </Switch>
    </ButtonContainer>
    <FlexContainer baseline inline gap="10px">
      <span>{email}</span>
      <Button primary invisible onClick={email ? logoutOnClick : logoinOnClick}>
        <FormattedMessage
          {...(email ? messages.logoutMenuItem : messages.loginMenuItem)}
        />
      </Button>
    </FlexContainer>
  </FlexContainer>
);

Header.propTypes = {
  title: PropTypes.node.isRequired,
  logoutOnClick: PropTypes.func.isRequired,
  newConferenceOnClick: PropTypes.func.isRequired,
  email: PropTypes.string,
};

Header.defaultProps = {
  email: '',
};

export default Header;



// WEBPACK FOOTER //
// ./components/organisms/Header/Header.js